import { render, staticRenderFns } from "./permissionsTab.vue?vue&type=template&id=01c72b11&"
import script from "./permissionsTab.vue?vue&type=script&lang=js&"
export * from "./permissionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports